import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AFCertificationDomain } from '../model/af.model';
import { AuthService } from './auth.service';
import { DateFormatPipe } from './dateFormatPipe';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CertificationService {
  
  constructor(private userService: AuthService ,private http: HttpClient, private dt: DateFormatPipe) {
  }

  getCertificationHistory(): Observable<AFCertificationDomain> {
    return this.http.post<AFCertificationDomain>(environment.api_uri + 'getProfessionalCertificationHistory', { 'verifyId' : this.userService.getVerifyId() })
    .pipe(
      map(response => {
        response.certificationList.forEach(item => {
          if(item.graduationDate){
            if(item.graduationDate){
              item.graduationDate = new Date(item.graduationDate);
            }
          }

          if(item.licenseOriginationDate){
            if(item.licenseOriginationDate){
              item.licenseOriginationDate = new Date(item.licenseOriginationDate);
            }
          }
         
        });
        return response;
      }));
  }

 
  
  submitCertificationHistory(AFCertificationDomain) : Observable<AFCertificationDomain> {
    const requestUrl = environment.api_uri + 'saveProfessionalCertification';

    AFCertificationDomain.certificationList.forEach(item => {
      if(item.graduationDate){
        if(item.graduationDate){
          item.graduationDate = moment(item.graduationDate).format('MM/DD/YYYY');
        }
      }
      
      if(item.licenseOriginationDate){
        if(item.licenseOriginationDate){
          item.licenseOriginationDate = moment(item.licenseOriginationDate).format('MM/DD/YYYY');
        }
      }
      
      
    });

    return this.http.post<AFCertificationDomain>(requestUrl, AFCertificationDomain);
  }

  
}



